// HomeTabUtils.ts
import { Flag } from "lucide-react";
import React from "react";

export const badgeBaseClass = "text-xs text-black p-[0.14275rem] flex items-center justify-center rounded-[6px] whitespace-nowrap";

export const STATUS_BADGE_COLORS: Record<string, string> = {
  "NOT STARTED": "#e8e8e8",
  "IN REVIEW (SUP)": "#FFC446",
  "IN REVIEW (PM)": "#FFC446",
  "COMPLETED": "#037010",
  "Pending Extension": "#BE68E0",
  "Extended": "#FF46E6",
  "READY_": "#5DC837",
  "ISSUES FOUND": "#FF5555",
  "CLOSED": "#898989",
  "Deleted": "#ACACAC",
  "IN PROGRESS": "#5DC837"
};

export const getStatusBadgeClassName = (statusName: string) => {
  const baseClass = "badge-status-custom1";
  const normalizedStatus = statusName.toUpperCase().trim();

  switch (normalizedStatus) {
    case "NOT STARTED": return `${baseClass} badge-status-custom-not-started`;
    case "IN REVIEW (SUP)": return `${baseClass} badge-status-custom-in-review-sup`;
    case "IN REVIEW (PM)":
    case "IN REVIEW": return `${baseClass} badge-status-custom-in-review`;
    case "COMPLETED": return `${baseClass} badge-status-custom-completed`;
    case "PENDING EXTENSION": return `${baseClass} badge-status-custom-pending-extension`;
    case "EXTENDED": return `${baseClass} badge-status-custom-extended`;
    case "READY_": return `${baseClass} badge-status-custom-ready`;
    case "ISSUES FOUND": return `${baseClass} badge-status-custom-issues`;
    case "CLOSED": return `${baseClass} badge-status-custom-closed`;
    default: return `${baseClass} badge-status-custom-default`;
  }
};

export const isLate = (dueDate: Date): boolean => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(dueDate);
    checkDate.setHours(0, 0, 0, 0);
    return checkDate < today;
  } catch {
    return false;
  }
};

export const isLateStatus = (dueDate: Date): string => {
  if (isLate(dueDate)) return "red-status";
  const now = new Date();
  const warningDate = new Date();
  warningDate.setDate(now.getDate() + 3);
  if (dueDate <= warningDate) return "yellow-status";
  return "green-status";
};

export const EmptyStateWidget = () => (
  <div className="common_content_inner relative min-h-[17.5rem]">
    <div className="task-list-container center-content coming-soon-wrapper">
      <div className="coming-soon-content">
        <div className="icon-wrapper-excellent">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
            <path d="M14.3999 26.3999C21.0273 26.3999 26.3999 21.0273 26.3999 14.3999C26.3999 7.77249 21.0273 2.3999 14.3999 2.3999C7.77249 2.3999 2.3999 7.77249 2.3999 14.3999C2.3999 21.0273 7.77249 26.3999 14.3999 26.3999Z" stroke="#00A63E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.7998 14.4L13.1998 16.8L17.9998 12" stroke="#00A63E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="excellent-text-container">
          <span className="excellent-text-title">Excellent Work!</span>
          <span className="excellent-text-subtitle">You're all caught up! No late tasks, CIRs, or emergency response items. Keep up the great work!</span>
        </div>
      </div>
    </div>
  </div>
);